const BADOOM_ROUTES = {
  AUTH: {
    LOGOUT: 'badoom.bo-seller.logout',
  },
  HOME: 'badoom.bo-seller.home',
  PASSWORD_RESET: 'badoom.bo-seller.password-reset',
  PDF: {
    TERMS_MERCHANT_ONBOARDING: 'badoom.bo-seller.pdf.terms-merchant-onboarding',
    CERTIFICATE_TO_TRANSPORT_INVESTIGATION:
      'badoom.bo-seller.pdf.certificate_to_transport_investigation',
  },
  DOCUSIGN_CGU: 'docusign_cgu',
  SOURCING: {
    DASHBOARD: 'badoom.bo-seller.sourcing.dashboard',
    INVOICES: {
      INDEX: 'badoom.bo-seller.sourcing.invoices',
    },
    OPTIONS: {
      INDEX: 'badoom.bo-seller.sourcing.options',
    },
  },
  LISTINGS: {
    PRODUCT: {
      CREATE: 'badoom.bo-seller.listings.product.create',
      DUPLICATE: 'badoom.bo-seller.listings.product.duplicate',
    },
  },
}

export const ROUTE_NAMES = {
  BADOOM: {
    ...BADOOM_ROUTES,
  },
  AUTH: {
    LOGIN: 'bo-seller.login',
    REGISTER: 'bo-seller.register',
  },
  CUSTOMER_CARE: {
    INDEX: 'bo-seller.customer-care',
    OPEN_TASKS: 'bo-seller.customer-care.open-tasks',
    ALL_REQUESTS: 'bo-seller.customer-care.all-requests',
    REQUEST_RESOLUTION: 'bo-seller.customer-care.request-resolution',
    /**
     * @deprecated The following route will be soon deprecated – maintenance mode only for the period of CP2.0 migration.
     */
    CUSTOMER_REQUEST: 'bo-seller.customer-care.customer-request',
    REQUEST: 'bo-seller.customer-care.request',
  },
  CUSTOMER_REVIEWS: {
    INDEX: 'bo-seller.reviews',
  },
  HOME: {
    INDEX: 'bo-seller.home',
  },
  INSIGHTS: {
    INDEX: 'bo-seller.insights',
  },
  INTERNATIONAL_ONBOARDING: {
    INDEX: 'bo-seller.international-onboarding',
    MARKETS: 'bo-seller.international-onboarding-markets',
  },
  INVOICES: {
    INDEX: 'bo-seller.invoices',
    WALLET: 'bo-seller.invoices.wallet',
    PAST_INVOICES: {
      INDEX: 'bo-seller.invoices.past-invoices',
      SALES: 'bo-seller.invoices.past-invoices.sales',
      TRADE_IN: 'bo-seller.invoices.past-invoices.trade-in',
    },
    GOODWILL_GESTURES: 'bo-seller.goodwill.goodwill-gestures',
    SELLER_COMPENSATION: 'bo-seller.seller-compensation',
    FINANCIAL_REPORT: 'bo-seller.financial-report',
  },
  LISTINGS: {
    INDEX: 'bo-seller.listings',
    TABS: {
      ACTIVE: 'bo-seller.listings.active',
      IN_VALIDATION: 'bo-seller.listings.in-validation',
      ARCHIVED: 'bo-seller.listings.archived',
      MISSING_INFOS: 'bo-seller.listings.missing-infos',
    },
    CREATE: 'bo-seller.listings.create',
    PRODUCT: {
      CREATE: 'bo-seller.listings.product.create',
      SEARCH: 'bo-seller.listings.product.search',
      DUPLICATE: 'bo-seller.listings.product.duplicate',
    },
  },
  NO_ACCESS: 'bo-seller.no_access',
  OPPORTUNITIES: {
    INDEX: 'bo-seller.opportunities',
    PRICING: 'bo-seller.opportunities.pricing',
    INVENTORY: 'bo-seller.opportunities.inventory',
  },
  OPTIONS: {
    INDEX: 'bo-seller.options',
    ADDRESSES: 'bo-seller.options.addresses',
    INTEGRATIONS: 'bo-seller.options.integrations',
    MARKETS: 'bo-seller.options.markets',
    PAYMENT: 'bo-seller.options.payment',
    PRICING: 'bo-seller.options.pricing',
    SHIPPING: 'bo-seller.options.shipping',
    SHIPPING_LEGACY: 'bo-seller.options.shipping.legacy',
    BATCH_LISTING_CREATION: 'bo-seller.options.batch-listing-creation',
    HYPERWALLET: {
      KYB: 'bo-seller.options.hyperwallet.kyb',
      TRANSFER_METHODS: 'bo-seller.options.hyperwallet.transfer-methods',
      CONFIRMATION: 'bo-seller.options.hyperwallet.confirmation',
    },
  },
  PROFILE: {
    INDEX: 'bo-seller.profile',
    HOME: 'bo-seller.profile.home',
    COMPANY_INFO: 'bo-seller.profile.company-info',
    LEGAL_DETAILS: 'bo-seller.profile.legal-details',
    CONTACT_DETAILS: 'bo-seller.profile.contact-details',
    USER_PERMISSIONS: 'bo-seller.profile.user-permissions',
  },
  ORDERS: {
    INDEX: 'bo-seller.orders',
    TABS: {
      ALL: 'bo-seller.orders.all',
      NEW: 'bo-seller.orders.new',
      PENDING: 'bo-seller.orders.pending',
      NEEDING_RESPONSE: 'bo-seller.orders.needing-response',
    },
  },
  SHIPPING: {
    CREATE_LABEL: 'bo-seller.shipping.create-label',
  },
  SUPPORT: 'bo-seller.support',
  BUYBACK: {
    ORDERS: {
      INDEX: 'bo-seller.buyback.orders',
      ALL: 'bo-seller.buyback.orders.all',
      ACTIVE: 'bo-seller.buyback.orders.active',
      PENDING: 'bo-seller.buyback.orders.pending',
      DETAILS: 'bo-seller.buyback.orders.details',
      CONVERSATION: 'bo-seller.buyback.orders.conversation',
    },
    WISHLIST: 'bo-seller.buyback.wishlist',
    WISHLIST_QA: 'bo-seller.buyback.wishlist-qa',
    CREATE_QUOTATION: 'bo-seller.buyback.create-quotation',
    CREATE_QUOTATION_QA: 'bo-seller.buyback.create-quotation-qa',
    SEARCH_PRODUCT: 'bo-seller.buyback.search-product',
    OPTIONS: {
      INDEX: 'bo-seller.buyback.options',
      ADDRESSES: 'bo-seller.buyback.options.addresses',
      PAYMENT: 'bo-seller.buyback.options.payment',
      UPDATE_PAYMENT_METHOD: 'bo-seller.buyback.options.payment.update',
      PRICING_RULES: 'bo-seller.buyback.options.pricing-rules',
    },
    UPDATE_PAYMENT_METHOD_CARD: 'bo-seller.buyback.update-payment-method-card',
    UPDATE_PAYMENT_METHOD_SEPA: 'bo-seller.buyback.update-payment-method-sepa',
    UPDATE_PAYMENT_METHOD_BACS: 'bo-seller.buyback.update-payment-method-bacs',
    UPDATE_PAYMENT_METHOD_ACH: 'bo-seller.buyback.update-payment-method-ach',
  },
  FEEDBACK: 'bo-seller.feedback',
  FRONT_OFFICE: {
    PRODUCT: {
      HOME: 'front-office.product',
    },
  },
  DOCUSIGN_CGU: 'bo-seller.docusign-cgu',
  ONBOARDING: {
    // A lot of routes seems duplicated, this is basically to case to create
    // another path for certains pages of the BO for onboarding seller
    INDEX: 'bo-seller.onboarding',
    HOME: 'bo-seller.onboarding.home',
    LISTINGS: {
      INDEX: 'bo-seller.onboarding.listings',
      TABS: {
        ACTIVE: 'bo-seller.onboarding.listings.active',
        MISSING_INFOS: 'bo-seller.onboarding.listings.missing-infos',
        IN_VALIDATION: 'bo-seller.onboarding.listings.in-validation',
        ARCHIVED: 'bo-seller.onboarding.listings.archived',
      },
      CREATE: {
        PRODUCT: {
          DUPLICATE: 'bo-seller.onboarding.listing.create-product-duplicate',
          SEARCH: 'bo-seller.onboarding.listings.create-product-search',
        },
        DETAILS: 'bo-seller.onboarding.listings.create-details',
      },
    },
    OPTIONS: {
      INDEX: 'bo-seller.onboarding.options',
      ADDRESSES: 'bo-seller.onboarding.options.addresses',
      ADDRESS_BOOK: 'bo-seller.onboarding.options.address-book',
      BUYBACK: 'bo-seller.onboarding.options.buyback',
      INTEGRATIONS: 'bo-seller.onboarding.options.integrations',
      HYPERWALLET: {
        KYB: 'bo-seller.onboarding.options.hyperwallet.kyb',
        TRANSFER_METHODS:
          'bo-seller.onboarding.options.hyperwallet.transfer-methods',
        CONFIRMATION: 'bo-seller.onboarding.options.hyperwallet.confirmation',
      },
      MARKETS: 'bo-seller.onboarding.options.markets',
      MY_INFO: 'bo-seller.onboarding.options.my-info',
      PAYMENT: 'bo-seller.onboarding.options.payment',
      PRICING: 'bo-seller.onboarding.options.pricing',
      SERVICES: 'bo-seller.onboarding.options.services',
      SHIPPING: 'bo-seller.onboarding.options.shipping',
      TRANSFER_METHODS_CONFIRMATION:
        'bo-seller.onboarding.options.transfer-methods-confirmation',
    },
    PROFILE: {
      INDEX: 'bo-seller.onboarding.profile',
      HOME: 'bo-seller.onboarding.profile.home',
      COMPANY_INFO: 'bo-seller.onboarding.profile.company-info',
      LEGAL_DETAILS: 'bo-seller.onboarding.profile.legal-details',
      CONTACT_DETAILS: 'bo-seller.onboarding.profile.contact-details',
      USER_PERMISSIONS: 'bo-seller.onboarding.profile.user-permissions',
    },
    SUPPORT: 'bo-seller.onboarding.support',
    FEEDBACK: 'bo-seller.onboarding.feedback',
  },
}
